// src/api/client.api.js
import axiosInstance from './axiosInstance';

export const clientLogin = (phone, password) =>
  axiosInstance.post('/client/login/', { phone, password });

export const fetchClientMe = () =>
  axiosInstance.get('/client/me/');

export const fetchClientBookings = () =>
  axiosInstance.get('/client/my-bookings/');

export const fetchClientBookingDetail = (bookingId) =>
  axiosInstance.get(`/client/my-bookings/${bookingId}/`);

export const clientChangePassword = (payload) =>
  axiosInstance.post('/client/change-password/', payload);